import { render } from "./PbxDashboard.vue?vue&type=template&id=65c6c2b6"
import script from "./PbxDashboard.vue?vue&type=script&lang=js"
export * from "./PbxDashboard.vue?vue&type=script&lang=js"

import "./PbxDashboard.vue?vue&type=style&index=0&id=65c6c2b6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__